var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Classificações de Chamados","newText":"Nova Classificação","table":_vm.table,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":true,"enableDelete":true,"enableView":false,"dataForm":_vm.dataForm,"toadd":"tickets-classifications/add/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }